import { Stack, styled } from '@mui/material';
import { portalPaths } from '@provision/portal-routes';
import { Navigate, Outlet } from 'react-router-dom';
import { isNullish } from 'remeda';
import { useGlobalStore } from 'src/store';

const SettingsLayout = styled(Stack, { name: 'SettingsLayout' })(() => ({
  position: 'relative',
  height: '100%',
  flexDirection: 'row',
}));

export const Settings = () => {
  const selectedPartnerId = useGlobalStore.use.selectedPartnerId();

  if (isNullish(selectedPartnerId)) {
    return <Navigate to={portalPaths.root()} replace />;
  }

  return (
    <SettingsLayout>
      <Outlet />
    </SettingsLayout>
  );
};
